<template>
  <div class="content">
    <h1 class="content__text">Страница находится в процессе разработки</h1>
  </div>



</template>
<script>
  export default {
    name: "404"
  };
</script>
<style lang="scss">
</style>
